import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=5cf79d86&scoped=true&lang=pug"
import script from "./ClientStats.vue?vue&type=script&lang=js"
export * from "./ClientStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf79d86",
  null
  
)

export default component.exports